var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',_vm._g(_vm._b({},'form',_vm.$props,false),_vm.event_listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }